import React, {
  useContext,
  useRef,
} from 'react';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import {
  VirtualTableColumnDef as ColumnDef,
  EditableTableMeta,
} from 'core/components/VirtualTable/types';
import {
  CellContext,
} from '@tanstack/react-table';
import {
  ServiceContext,
} from 'views/EMR/components/ServiceLookup/ServiceContext';
import {
  CodeWithDescription,
} from 'views/EMR/components/ServiceLookup/columns/serviceName';
import ToolTip from 'core/components/Tooltip';

function IcdCodeCell({ row, table }: CellContext<VisitNoteServiceCode, unknown>) {
  const { removeData } = table.options.meta as EditableTableMeta<VisitNoteServiceCode>;
  const { description, code } = row.original ?? {};
  const { readonly } = useContext(ServiceContext);
  const descriptionRef = useRef<HTMLSpanElement>(null);

  return (
    <div className="flex gap-2 items-center min-w-0">
      <CodeWithDescription
        value={code ?? ''}
        readonly={readonly}
        classes={{ root: 'shrink-0' }}
        onRemove={() => { removeData?.(row.index, row.original); }}
      />
      <ToolTip title={description} auto ref={descriptionRef}>
        <span
          ref={descriptionRef}
          className="text-xs min-w-0 truncate text-gray-700"
        >
          {description}
        </span>
      </ToolTip>
    </div>
  );
}

export default {
  id: 'code',
  accessorKey: 'code',
  header: '',
  size: 800,
  maxSize: 800,
  cell: IcdCodeCell,
} as ColumnDef<VisitNoteServiceCode>;
